import { Link } from "react-router-dom";
//   if (!project) return (<div className="min-h-screen flex items-center justify-center"><div className="text-center"><h1 className="text-4xl text-[#0A0A0A] mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Project Not Found</h1><Link to={`/projects`} className="text-[#0A4F3B]">Back to Projects</Link></div></div>);

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F8F5] px-6">
      <div className="max-w-xl text-center" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
        <h1 className="text-[110px] font-bold text-[#0A4F3B] leading-none">
          404
        </h1>

        <h2 className="mt-4 text-3xl font-semibold text-[#15242E]">
          Page Not Found
        </h2>

        <p className="mt-4 text-900 leading-7">
          Sorry, the page you're looking for doesn't exist or may have been
          moved.
        </p>

        <div className="mt-10 flex justify-center gap-4">
          <Link
            to="/"
            className="px-6 py-3 rounded-md bg-[#0A4F3B] text-white transition-all duration-300 "
          >
            Back to Home
          </Link>

          <button
            onClick={() => window.history.back()}
            className="px-6 py-3 rounded-md border border-[#0A4F3B] text-[#0A4F3B] transition-all duration-300 hover:bg-[#0A4F3B] hover:text-white"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;